import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query"
import { getProgramList } from "../../../../service/program";

const programColumns: ColumnsType<IProgramForList> = [
    {
        title: 'No',
        dataIndex: 'id',
    },
    {
        title: '프로그램명',
        dataIndex: 'title',
        sorter: (a, b) => a?.title?.localeCompare(b?.title),
        render: (title: string | undefined, data) => <Link to={`/wellness-program/program/${data?.id}`}>{title?.length === 0 ? '--' : title}</Link>
    },
    {
        title: '생성일',
        dataIndex: 'createDateTime',
        render: (createDateTime: string | undefined) => dayjs(createDateTime)?.format('YYYY.MM.DD'),
        sorter: (a, b) => dayjs(a.createDateTime)?.diff(dayjs(b.createDateTime)),
    },
    {
        title: '프로그램 기간',
        dataIndex: 'programPeriod',
        render: (programPeriod: [string | undefined, string | undefined]) => `${dayjs(programPeriod?.[0])?.format('YYYY.MM.DD')} ~ ${dayjs(programPeriod?.[1])?.format('YYYY.MM.DD')}`
    },
    {
        title: '게시여부',
        dataIndex: 'isDisplay',
        render: (isDisplay: boolean | undefined) => isDisplay ? '게시' : '미게시'
    },
    {
        title: '예약 목록',
        dataIndex: 'bookingCnt',
        render: (bookingCnt: number | undefined, data) => <Link to={`/wellness-program/program/${data.id}/booking`}>{bookingCnt?.toLocaleString()}</Link>
    },
]

const defaultFieldListMap: IProgramField = {
    program: ['id', 'isDisplay', 'title', 'createDateTime', 'programPeriod', 'bookingCnt'],
}

const useGetProgramList = (fieldListMap: IProgramField = defaultFieldListMap) => {
    const query = useQuery({
        queryKey: ['getProgramList', fieldListMap],
        queryFn: () => getProgramList<IProgramForList[]>(fieldListMap),
        select: res => res.data.data.getProgramList
    })
    return query;
}

export { programColumns, useGetProgramList }